import React from 'react'
import {AuthStoreTokenData} from "../models/UserDetail";

const UserContext = React.createContext<AuthStoreTokenData | null>(null);

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;

export default UserContext;